<template>
  <div v-if="images.length > 0" class="catalog-single__img">
    <img v-srcset :src="`${currentImage}?w=400`" alt="">
    <div>
      <div class="catalog-single__img-grid">
        <template v-for="(img, index) in images.slice(0,4)">
          <img
            :key="index" v-srcset :src="`${img.thumb}?w=90`"
            alt=""
            @click="setCurrent(img)"
          >
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CatalogProductImages',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: {},
    };
  },
  computed: {
    currentImage() {
      return this.current.display_image || this.images[0].display_image;
    },
  },
  methods: {
    setCurrent(image) {
      this.current = image;
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-single{
    &__img{
        img{
            width: 100%;
        }
    }

    &__img-grid{
        display: grid;
        padding-top: 16px;
        gap: 14px;
        grid-template-columns: repeat(4, minmax(80px, 100px));
        img{
            width: 90px;
            cursor: pointer;
            // height: 40px;
        }
    }
}
</style>
